import { CommonHelper } from '../helpers/common';
import { GameModel } from './game.model';

export class CalendarModel{
    public title = '';
    public games: GameModel[] = [];
    public get date(): Date {
        const dateTitle = CommonHelper.replaceMonthToNumber(this.title);
        const dateTitleParts = dateTitle.split(' ');
        const date: Date = new Date();
        if(typeof dateTitleParts[3] !== 'undefined')
            date.setFullYear(parseInt(dateTitleParts[3]));
        if(typeof dateTitleParts[1] !== 'undefined')
            date.setDate(parseInt(dateTitleParts[1]));
        if(typeof dateTitleParts[2] !== 'undefined')
            date.setMonth(parseInt(dateTitleParts[2]) - 1);
        return this.secondDate !== null ? this.secondDate : date;
    }

    public get dateDay(): string {
        return this.date.getDate() < 10 ? '0' + this.date.getDate() : this.date.getDate().toString();
    }

    public get dateMonth(): string {
        return this.date.getMonth() + 1 < 10 ? '0' + (this.date.getMonth() + 1) : (this.date.getMonth() + 1).toString();
    }

    public get dateYear(): string {
        return this.date.getFullYear() < 10 ? '0' + this.date.getFullYear() : this.date.getFullYear().toString();
    }

    public secondDate: any = null;

    public get isCaribbean(): boolean {
        const startDate = new Date();
        startDate.setDate(31);
        startDate.setMonth(0);

        const endDate = new Date();
        endDate.setDate(7);
        endDate.setMonth(1);

        return this.date >= startDate && this.date <= endDate;
    }
}